import { InvoicesDataGridBase } from "src/components/views/erp/sales/invoicing/InvoicesDataGridBase.tsx";

export interface CustomerInvoicesDataGridProps {
	customerId: number;
}

export const CustomerInvoicesDataGrid = ({ customerId }: CustomerInvoicesDataGridProps) => {
	return <InvoicesDataGridBase customerId={customerId} />;
};
